import { useTranslation } from "react-i18next";
import { Typography } from "@mui/material";

const EstimatedTravelTimeMessage = ({
  time,
  distance,
}: {
  time: string;
  distance: string;
}) => {
  const { t } = useTranslation('common');

  return (
    <Typography>
      {t('reservation.estimatedTravelTime', {
        time,
        distance,
      })}
    </Typography>
  );
};

export { EstimatedTravelTimeMessage };